import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AUTHED_ROUTE_REDIRECT, UNAUTHED_ROUTE_REDIRECT } from 'config/constants';

/*
 * Route only for authed clients
 */
export class AuthedRoute extends Component {
    static propTypes = {
        component: PropTypes.func.isRequired,
        isAuthed: PropTypes.bool.isRequired,
        path: PropTypes.string.isRequired,
        location: PropTypes.object
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isAuthed !== this.props.isAuthed
            || nextProps.path !== this.props.path
            || nextProps.location.pathname !== this.props.location.pathname) {
            return true;
        }

        return false;
    }

    render() {
        if (this.props.isAuthed) {
            return (
                <Route {...this.props} />
            );
        }

        return (
            <Redirect to={{
                pathname: AUTHED_ROUTE_REDIRECT,
                state: { from: this.props.location }
            }} />
        );
    }
}

/*
 * Route only for un-authed clients
 */
export class UnauthedRoute extends Component {
    static propTypes = {
        component: PropTypes.func.isRequired,
        isAuthed: PropTypes.bool.isRequired,
        path: PropTypes.string.isRequired,
        location: PropTypes.object
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isAuthed !== this.props.isAuthed
            || nextProps.path !== this.props.path) {
            return true;
        }

        return false;
    }

    render() {
        if (!this.props.isAuthed) {
            return (
                <Route {...this.props} />
            );
        }

        return (
            <Redirect to={{
                pathname: UNAUTHED_ROUTE_REDIRECT,
                state: { from: this.props.location }
            }} />
        );
    }
}
